import type { SimulationUploadErrorType } from '~/store/simulation/types';

export function getSimulationUploadErrorMessage(errorType: SimulationUploadErrorType): {
  title: string;
  description: string;
} {
  switch (errorType) {
    case 'invalid_file':
      return {
        title: 'The file could not be processed',
        description: 'Please check the data format and try again',
      };
    case 'no_rows_found':
      return {
        title: 'The file has no rows to process',
        description: 'Please provide a valid file',
      };
    case 'no_valid_rows_found':
      return {
        title: 'The file was processed but has no valid rows',
        description: 'Please check the date formats of the file you provided',
      };
    case 'origin_postal_codes_limit_exceeded':
      return {
        title: 'The file was processed but has too many origin postal codes',
        description: 'No more than 50 origin postal codes are allowed per file',
      };
  }
}
